<template>
  <article class="container margin-t-large pt-0">
    <article class="accordion">
      <div class="accordion-item">
        <a
          class="faq-accordion-header accordion-header"
          role="button"
          @click="accordianClick($event)"
          :aria-controls="`faq-accordian-${iterator}`"
          aria-expanded="false"
          data-event="collapse"
                  data-action="open"
                  data-name="onclick"
                  data-type="click"
                  data-region="main content"
                  data-section="faq"
                  :data-text="question.toLowerCase()"
        >
          <h2>{{question}}</h2>
        </a>
        <dl :id="`faq-accordian-${iterator}`" class="faq-accordion-body accordion-body" role="tabpanel">
          <div class="border-top-solid"></div>
          <p v-html="answer"></p>
        </dl>
      </div>
    </article>
  </article>
</template>

<script>
export default {
  props: {
    question: String,
    answer: String,
    iterator: Number
  },
  methods:{
    accordianClick(e){
      let status;
      let event = 'open';
    const accordionItem = document.querySelectorAll(".accordion-item");
      if (e.currentTarget.parentNode.classList.contains("active")) {
        e.currentTarget.parentNode.classList.remove("active");
        e.currentTarget.setAttribute("aria-expanded", "false");
        e.currentTarget.setAttribute("data-action", "open");
        event = "close";
        status = 'collapse_close';
      } else {
        Array.prototype.forEach.call(accordionItem, e => {
          e.classList.remove("active");
        });
        e.currentTarget.parentNode.classList.add("active");
        if (
          e.currentTarget.parentNode.getAttribute("aria-expanded") === "true" ||
          e.currentTarget.parentNode.getAttribute("data-action") === "close"
        ) {
          e.currentTarget.setAttribute("aria-expanded", "false");
          e.currentTarget.setAttribute("data-action", "open");
          status = 'collapse_open';
        } else {
          e.currentTarget.setAttribute("aria-expanded", "true");
          e.currentTarget.setAttribute("data-action", "close");
          status = 'collapse_open';
        }
      }

       utag.link({
        event: 'collapse',
        action: event,
        name: 'onclick',
        type: 'click',
        region: 'main content',
        section: 'faq',
        text: this.question.toLowerCase(),
        tealium_event: status
      })
    }
  },
};
</script>

